import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Division from './Division.js';

import './Home.css';

class Home extends Component {

    render() {
        return (
            <section id={this.props.id} className='gradient-primary text-white vertical-center'>

                <Division color='white' />

                <Container>

                    <Row data-aos='fade-up' data-aos-duration='1500'>

                        <Col md className='text-md-start mt-5 mt-lg-0'>

                            <div>
                                <h1 className='display-3'>
                                    <span className='gradient-secondary gradient-text fw-bold'>Hello GitHub.</span>
                                    <br/>
                                    {this.props.title}
                                </h1>
                                <p className='lead'>{this.props.content}</p>
                            </div>

                            <div className='d-grid gap-2 d-md-block my-5'>

                                <Button block variant='primary' size='lg' href={this.props.hrefPrimary} className='me-md-2 drop-shadow-dark'>Discover more</Button>
                                <Button block variant='secondary' size='lg' href={this.props.hrefSecondary} className='ms-md-2 drop-shadow-dark' style={{'background': 'rgba(255,255,255,0.3)' }}>Projects</Button>

                            </div>

                        </Col>

                        <Col md className='text-center vertical-center'>
                            {this.props.display}
                        </Col>

                    </Row>

                </Container>

            </section>
        );
    }

}

export default Home;